module.exports = __webpack_public_path__ + "static/media/educator-active.6e0b1205.svg";